import { DotCarousel } from '@theme/dot-carousel';

/**
 * <shop-the-look> — progressive enhancement for the three-column mobile
 * carousel of the "Shop the look" section. Desktop and the one/two-column
 * variants render as a static grid with no scroller, so the base class finds
 * no hooks and does nothing.
 *
 * Swipe + dots behaviour lives in the shared DotCarousel base; this only names
 * the section's own hooks.
 */
class ShopTheLook extends DotCarousel {
  static scrollerSelector = '[data-stl-scroller]';
  static dotsSelector = '[data-stl-dots]';
  static dotClass = 'stl__dot';
}

if (!customElements.get('shop-the-look')) {
  customElements.define('shop-the-look', ShopTheLook);
}
